import Axios from "axios";
import { handleApiError } from "src/common/api/apiErrorHandler";
import { BaseCustomerPreferences } from "src/common/types/customerPrefs";

export default class InternalCustomerPrefsApi {
  static async patchDefaultPrefs(prefs: BaseCustomerPreferences): Promise<BaseCustomerPreferences> {
    try {
      const response = await Axios.patch<BaseCustomerPreferences>("/api/customers/preferences/default", prefs);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  static async getDefaultPrefs(): Promise<BaseCustomerPreferences> {
    try {
      const response = await Axios.get<BaseCustomerPreferences>("/api/customers/preferences/default");
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
}
